import { createReducer, on } from '@ngrx/store';
import { TipologieCantieriActions } from './tipologie-cantieri.actions';
import { TipologiaCantiere } from '../../core/models/tipo-cantiere.model';

export interface TipologieCantieriState {
  items: TipologiaCantiere[];
  loaded: boolean;
  loading: boolean;
  error: string | null;
  opLoading: boolean;
  opError: string | null;
  lastCreatedTipologia: TipologiaCantiere | null;
  createSuccessCount: number;
  createFailureCount: number;
}

export const initialState: TipologieCantieriState = {
  items: [],
  loaded: false,
  loading: false,
  error: null,
  opLoading: false,
  opError: null,
  lastCreatedTipologia: null,
  createSuccessCount: 0,
  createFailureCount: 0,
};

export const tipologieCantieriReducer = createReducer(
  initialState,

  on(TipologieCantieriActions.loadList, (s) =>
    s.loaded ? s : { ...s, loading: true, error: null }
  ),
  on(TipologieCantieriActions.loadListSuccess, (s, { items }) => ({
    ...s,
    loading: false,
    loaded: true,
    items,
  })),
  on(TipologieCantieriActions.loadListFailure, (s, { error }) => ({
    ...s,
    loading: false,
    error,
  })),

  on(TipologieCantieriActions.create, (s) => ({ ...s, opLoading: true, opError: null, lastCreatedTipologia: null })),
  on(TipologieCantieriActions.createSuccess, (s, { item }) => ({
    ...s,
    opLoading: false,
    items: [...s.items, item],
    lastCreatedTipologia: item,
    createSuccessCount: s.createSuccessCount + 1,
  })),
  on(TipologieCantieriActions.createFailure, (s, { error }) => ({
    ...s,
    opLoading: false,
    opError: error,
    createFailureCount: s.createFailureCount + 1,
  })),
);
